import utils from '@/utils'

/**
 * APIレスポンス
 */
export default class Response {
  /**
   * コンストラクタ
   * @param code レスポンスコード
   * @param data データ
   */
  constructor (code, data) {
    this._code = utils.cast.int(code)
    this._data = data

    if (!this._code) {
      this._code = 400
    }
    if (!this._data) {
      this._data = {}
    }
    if (!this._data.state) {
      this._data.state = -1
    }
    if (!this._data.data) {
      this._data.data = {}
    }
    if (!this._data.functionError) {
      this._data.functionError = {errorCode: 'SYSERR'}
    }
    if (!this._data.systemError) {
      this._data.systemError = {}
    }
  }

  /**
   * レスポンスコードを取得
   */
  get code () {
    return this._code
  }
  /**
   * 通信状態を取得
   */
  get state () {
    return this._data.state
  }
  /**
   * データを取得
   */
  get data () {
    return this._data.data
  }
  /**
   * 機能エラーを取得
   */
  get functionError () {
    return this._data.functionError
  }
  /**
   * システムエラーを取得
   */
  get systemError () {
    return this._data.systemError
  }

  /**
   * 成功可否
   */
  get isSuccess () {
    if (this.code < 200 && this.code >= 300) {
      return false
    }
    if (this.state !== 1) {
      return false
    }
    if (!this.data) {
      return false
    }

    return true
  }
}
